import { useQuery } from "@tanstack/react-query";
import lensService from "../../../services/lensService";

const useRun = (identifier: string | undefined) =>
    useQuery({
        queryKey: ["lens", "run", identifier],
        queryFn: () => lensService.fetchRun(identifier as string),
        enabled: !!identifier,
        refetchInterval: (query) => (query.state.data?.status === "running" ? 5000 : false),
    });

export default useRun;
